import {
  CORRECTIVE_ACTION_HEADER_NAME,
  FieldGroupOrderingTypes,
  IField,
  IFieldGroup,
  IFieldTypes,
  TaskHeaderExtraFields,
} from "../../typings";

export const META_TITLE_NAME = "meta.title";
export const META_DUEDATE_NAME = "meta.dueDate";

export const DEFAULT_CA_META_FIELDS: IField[] = [
  {
    fieldType: IFieldTypes.textField,
    label: "Short Description",
    name: META_TITLE_NAME,
    required: true,
    span: 4,
    meta: {
      displayInNotification: true,
    },
  },
  {
    fieldType: IFieldTypes.dateField,
    label: "Due Date",
    name: META_DUEDATE_NAME,
    required: true,
    span: 1,
    outputFormat: "number",
    meta: {
      displayInNotification: true,
    },
  },
];

export const DEFAULT_HEADER_CONFIG: IFieldGroup & TaskHeaderExtraFields = {
  name: CORRECTIVE_ACTION_HEADER_NAME,
  label: "Corrective Action Header",
  allowUserAssignment: true,
  allowRoleAssignment: false,
  description: "",
  ordering: [
    {
      orderIdx: 0,
      entryIdx: 0,
      type: FieldGroupOrderingTypes.field,
      name: "ownerids",
    },
    {
      orderIdx: 1,
      entryIdx: 1,
      type: FieldGroupOrderingTypes.field,
      name: "roleids",
    },
  ],
  groups: [],
  fields: [
    {
      fieldType: IFieldTypes.userSelectField,
      multiple: true,
      label: "Assign To",
      name: "ownerids",
      span: 2,
      selectedStyle: "name",
    },
    {
      fieldType: IFieldTypes.roleSelectField,
      label: "Assign to Role",
      multiple: true,
      name: "roleids",
      span: 2,
    },
  ],
  headless: true,
  min: 1,
  max: 1,
};

export const META_TITLE_COMPAT_NAME = "meta-title";
export const META_DUEDATE_COMPAT_NAME = "meta-duedate";

export const metaNameCompatibilityMap: Record<string, string> = {
  [META_TITLE_NAME]: META_TITLE_COMPAT_NAME,
  [META_DUEDATE_NAME]: META_DUEDATE_COMPAT_NAME,
};

export const DEFAULT_HEADER_CONFIG_NAMES = [
  META_TITLE_COMPAT_NAME,
  META_DUEDATE_COMPAT_NAME,
  ...DEFAULT_CA_META_FIELDS.map((f) => f.name),
  ...DEFAULT_HEADER_CONFIG.fields!.map((f) => f.name),
  ...DEFAULT_HEADER_CONFIG.groups!.map((g) => g.name),
];
